import { api } from "../config/api";

export const purchaseSubscription = async (plan) => {
    const response = await api.post("/subscriptions/purchase", { plan });
    return response.data;
};

export const createWalletDeposit = async ({ amount, paymentMethod }) => {
    const response = await api.post("/wallet/deposit", {
        amount,
        paymentMethod
    });

    return response.data;
};

export const getWallet = async () => {
    const response = await api.get("/wallet");
    return response.data;
};

export const withdrawWallet = async ({ amount, pixKey, pixKeyType }) => {
    const response = await api.post("/wallet/withdraw", {
        amount,
        pixKey,
        pixKeyType
    });
    return response.data;
};

export const pendingPixDeposit = async () => {
    const response = await api.get("/wallet/pending-pix");
    return response.data;
}

export const getSavedCards = () =>
    api.get('/wallet/cards').then((res) => res.data);

export const addCreditCard = (card) =>
    api.post('/wallet/cards', { card }).then((res) => res.data);

export const removeCreditCard = (cardId) =>
    api.delete(`/wallet/cards/${cardId}`);

export const depositWithCard = ({ amount, savedCardId, newCard, saveCard = true }) =>
    api.post('/wallet/deposit/card', {
        amount,
        savedCardId: savedCardId ?? null,
        newCard: newCard ?? null,
        saveCard
    }).then((res) => res.data);